import { TableTextStyles } from 'ag-common-lib/lib/template-builder/table-text-styles';
import { TemplateExcursionsSet } from 'ag-common-svc/lib/components/administration/template-builder/template-editor-page/models/template-builder-template.model';
import { DEFAULT_TABLE_STYLES, TableColorScheme, TableStylePreset } from 'ag-common-lib/lib';

export class ExcursionsTableWidgetData {
  title: string = '';
  textStyles?: TableTextStyles;
  includePreferences: boolean = true;
  // padding: Padding = new Padding();
  selectedStyle: TableStylePreset = TableStylePreset.Blue;
  events: string; // event dbId
  excursionsSet: TemplateExcursionsSet = TemplateExcursionsSet.all;
  customColorScheme: TableColorScheme = {
    header: '',
    color1: '',
    color2: '',
  };

  constructor() {}

  get currentColorScheme(): TableColorScheme {
    return this.selectedStyle === TableStylePreset.Custom
      ? this.customColorScheme
      : DEFAULT_TABLE_STYLES[this.selectedStyle];
  }
}
